export const NOTES_CHARACTER_LIMIT = 50000;

export const GENDERS = [
  {
    value: "O",
    label: "Other",
  },
  {
    value: "M",
    label: "Male",
  },
  {
    value: "F",
    label: "Female",
  },
];

export const SELF_INSURED_TYPE = {
  INDIVIDUAL: "I",
  OTHER: "O",
};

export const PLAN_INSURANCE_TYPE = {
  NO_FAULT: "D",
  WORKERS_COMP: "E",
  LIABILITY: "L",
};

// random date for when the date pickers open up DOB
export const INITIAL_CLAIMANT_BIRTH_DATE = "01/01/1975";

// not reportable before date
export const DOI_UNREPORTABLE_BEFORE_DATE = new Date("12/05/1980");

export const PLAN_INSURANCE_TYPES = [
  {
    value: "no_fault",
    label: "No-Fault",
  },
  {
    value: "workers_comp",
    label: "Workers' Compensation",
  },
  {
    value: "liability",
    label: "Liability",
  },
];
